import { IconBrandYoutube } from '@tabler/icons-react';
import _debounce from 'lodash/debounce';
import React, { useState } from 'react';
import { toast } from 'sonner';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';

const YoutubeBlock = ({ createBlockFunction, cancelFunction }) => {

    const [ytData, setYtData] = useState(null);

    const onCancel = () => {
        if (cancelFunction) {
            cancelFunction();
        }
    }

    const getYoutubeData = async (e) => {
        let regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        if (regex.test(document.getElementById('yt-url')?.value?.trim())) {
            let postData = {
                "url": document.getElementById('yt-url')?.value?.trim(),
            }
            let resp = await postApi(postData, urlApi.getYoutubeDataFromLink);
            setYtData(resp);
        } else {
            toast.error("Invalid YouTube URL")
        }
    }

    const create = () => {
        if (document.getElementById('yt-url').value?.trim()) {
            let data = {
                blockType: 3,
                images: [{
                    title: ytData?.data?.title,
                    destinationUrl: document.getElementById('yt-url').value?.trim(),
                    image: ytData?.data?.thumbnail,
                    shortLinkDomain: 'advy.me',
                }],
            }
            createBlockFunction(data);
            onCancel();
        } else {
            toast.error("Please enter a YouTube URL")
        }
    };

    return (
        <div className='p-3 rounded-lg border-2 border-primary'>
            <p className="flex items-center text-sm font-semibold gap-2"> <IconBrandYoutube size={18} /> Youtube </p>
            <div className='w-full mb-4'>
                <p className="text-md font-semibold mb-1.5">Youtube Video URL</p>
                <input type="text" className="form-control mb-2 w-full text-sm" id='yt-url' placeholder="ex. https://www.youtube.com/embed/id" onChange={_debounce((e) => getYoutubeData(e), 300)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            getYoutubeData();
                        }
                    }}
                />
                {ytData?.responseCode == 500 && <p className='text-xs text-red-700'>{ytData?.message}</p>}
            </div>

            <div className='flex flex-col'>
                <label htmlFor="" className='mb-1 font-semibold'>Short Link Domain</label>
                <select name="" id="" className='form-control w-full'>
                    <option selected disabled value="">advy.me</option>
                </select>
            </div>

            <div className="flex mt-3 items-center gap-4">
                <div className="bg-[#dbe0eb]">
                    <img src={ytData?.data?.thumbnail ? ytData?.data?.thumbnail : process.env.PUBLIC_URL + "/images/blocks/youtube.png"} alt="" className='h-28 rounded-md' />
                </div>
                <div>
                    {ytData?.data?.title && <p className="mb-0 text-md font-semibold text-[#686C8F]">Video Title</p>}
                    <p className="mb-0 font-medium">{ytData?.data?.title ?? "Add a YouTube URL above to preview the video"}</p>
                </div>
            </div>

            <div className="flex justify-end items-center mt-3 gap-3">
                <button className="font-semibold text-sm border-2 border-primary px-3 py-1.5 rounded-full" onClick={() => onCancel()}>Cancel</button>
                <button className="font-semibold text-sm text-white bg-primary px-3 py-2 rounded-full" onClick={() => create()}>Create</button>
            </div>

        </div>
    )
}

export default YoutubeBlock